import ArgonBox from "components/ArgonBox";
import AdminDashboard from "layouts/dashboards/crm/AdminDashboard";
import SuperAdminDashboard from "layouts/dashboards/crm/SuperAdminDashboard copy";

const AdminRoutes = [
  {
    type: "collapse",
    name: "Admin",
    key: "admin",
    route: "/superadmin",
    icon: <ArgonBox component="i" color="primary" fontSize="14px" className="ni ni-shop" />,
    noCollapse: true,
    component: <SuperAdminDashboard />,
  },
];

export default AdminRoutes;
